import { Item } from '../types'

/**
 * Gets the main image URL for an item, with fallback to legacy imageUrl
 */
export function getMainImageUrl(item: Item): string | undefined {
  // New system: use images array with mainImageIndex
  if (item.images && item.images.length > 0) {
    const mainIndex = item.mainImageIndex ?? 0
    return item.images[mainIndex] || item.images[0]
  }
  
  // Fallback to legacy imageUrl for backward compatibility
  return item.imageUrl
}

/**
 * Gets all image URLs for an item
 */
export function getAllImageUrls(item: Item): string[] {
  if (item.images && item.images.length > 0) {
    return item.images
  }
  
  // Fallback to legacy imageUrl
  if (item.imageUrl) {
    return [item.imageUrl]
  }
  
  return []
}

/**
 * Checks if an item has any images
 */
export function hasImages(item: Item): boolean {
  return getAllImageUrls(item).length > 0
}
